/**
 * computeFuelOptimizationBreakdown — 10/02/2026 (Lot N P1).
 *
 * Retour user prod : « Karim Benali, Il est censé faire baisser le
 * carburant de -5% mais comme tu peux le constater je reste sur une base
 * 100 sur le dashboard carburant. Même chose pour cuve et pompe dédiée. »
 *
 * Centralise le calcul des réductions carburant (Karim, cuve, pompe,
 * résolution active) pour les exposer au widget FuelEvolutionInsight.
 *
 * @returns {{
 *   investments: number,   // somme des -% via activeInvestments (cuve, pompe...)
 *   support: number,       // -5 % si Karim Benali recruté
 *   resolution: number,    // -X % résolution active (eco-conduite, etc.)
 *   total: number,         // somme cumulée capée à 0.50 (50 %)
 *   sources: Array<{ label, pct, kind }>, // pour tooltip / breakdown UI
 * }}
 */
import { INVESTMENTS } from '../../data/investments';

export function computeFuelOptimizationBreakdown(state) {
  const sources = [];

  // 1) Investissements (cuve carburant, pompe diesel, contrat fournisseur,
  //    télémétrie, etc.) → `impactMultiplier < 0` dans data/investments.js
  let investmentsPct = 0;
  Object.keys(state?.activeInvestments || {}).forEach(invId => {
    const inv = INVESTMENTS.find(i => i.id === invId);
    if (inv && (inv.impactMultiplier || 0) < 0) {
      const pct = Math.abs(inv.impactMultiplier);
      investmentsPct += pct;
      sources.push({ label: inv.name, pct, kind: 'investment' });
    }
  });

  // 2) Support roles (Karim Benali = role-karim-benali) → -5 %
  let supportPct = 0;
  const hired = state?.hiredSupport || {};
  if (hired['role-karim-benali']) {
    supportPct = 0.05;
    sources.push({ label: 'Karim Benali (Resp. carburant)', pct: 0.05, kind: 'support' });
  }

  // 3) Résolution active (drv-burnout-alert, eco-conduite, etc.)
  let resolutionPct = 0;
  const resolutionActive = state?.activeResolution
    && Number.isFinite(state.activeResolution.expiresOnDay)
    && (state.totalDays || 0) < state.activeResolution.expiresOnDay;
  if (resolutionActive && state.activeResolution.fuelDiscount) {
    resolutionPct = state.activeResolution.fuelDiscount;
    sources.push({
      label: state.activeResolution.name || 'Résolution active',
      pct: resolutionPct,
      kind: 'resolution',
    });
  }

  const total = Math.min(0.50, investmentsPct + supportPct + resolutionPct);

  return {
    investments: investmentsPct,
    support: supportPct,
    resolution: resolutionPct,
    total,
    sources,
  };
}
